import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const MapIcon = (props: IconProps) => (
  <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24Z" fill="none" />
    <path
      d="M9.42471 16.3568L6.56524 17.7296C6.304 17.8531 6 17.6631 6 17.3733V7.99693C6 7.84493 6.0855 7.70718 6.22325 7.64068L9.41996 6.10645V16.3568H9.42471Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0981 16.4656L14.9014 17.9998V7.74943L17.7608 6.37669C18.0221 6.25319 18.3261 6.44319 18.3261 6.73294V16.1046C18.3261 16.2566 18.2406 16.3943 18.1028 16.4608L18.0981 16.4656Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.36816 16.3565L14.9019 18V9.00854L9.36816 6.11084V16.3565Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6844 5.00884C12.6156 5.12284 11.7607 6.00158 11.6657 7.07507C11.6324 7.46456 11.6989 7.83981 11.8414 8.17231L13.2854 11.1743C13.5514 11.7253 14.3304 11.7253 14.5964 11.1743L16.0404 8.17231C16.1591 7.89681 16.2209 7.59756 16.2209 7.27932C16.2209 5.93508 15.0619 4.86634 13.6844 5.01359V5.00884ZM13.9409 7.96806C13.3946 7.96806 12.9529 7.52631 12.9529 6.98007C12.9529 6.43382 13.3946 5.99208 13.9409 5.99208C14.4871 5.99208 14.9289 6.43382 14.9289 6.98007C14.9289 7.52631 14.4871 7.96806 13.9409 7.96806Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
      strokeMiterlimit="10"
    />
  </Icon>
);
